import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import OrdersTable from "../../components/orderTables/orderTable";
import { manageOrderDetail } from "../../redux/actions/manageOrderActions";
import "./manageOrders.css";
import ImageViewModal from "../../components/modals/ImageViewModal";
import eye from "../../../src/assets/icons/eye.svg";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { TableContainer } from "@mui/material";

const ManageOrderDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [orderDetailData, setOrderDetailData] = useState(null);
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    console.log(params?.id);
    dispatch(manageOrderDetail(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data);
    setOrderDetailData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };
  const customerDetails = [
    {
      heading: "Customer ID",
      title:
        orderDetailData?.customer_type == "doctor"
          ? orderDetailData?.doctor?.code
          : orderDetailData?.customer_type == "pharmacy"
          ? orderDetailData?.pharmacy?.code
          : "--",
    },
    {
      heading: "Customer Name",
      title:
        orderDetailData?.customer_type == "doctor"
          ? orderDetailData?.doctor?.name
          : orderDetailData?.customer_type == "pharmacy"
          ? orderDetailData?.pharmacy?.pharmacy_name
          : "--",
    },
    {
      heading: "Customer Type",
      title:
        orderDetailData?.customer_type == "doctor"
          ? "Doctor"
          : orderDetailData?.customer_type == "pharmacy"
          ? "Pharmacy"
          : "--",
    },
    {
      heading: "Division",
      title: orderDetailData?.vendorDivision?.name
        ? orderDetailData?.vendorDivision?.name
        : "--",
    },
    {
      heading: "State",
      title:
        orderDetailData?.customer_type == "doctor"
          ? orderDetailData?.doctor?.state?.name
          : orderDetailData?.customer_type == "pharmacy"
          ? orderDetailData?.pharmacy?.state?.name
          : "--",
    },
    {
      heading: "City",
      title:
        orderDetailData?.customer_type == "doctor"
          ? orderDetailData?.doctor?.city?.name
          : orderDetailData?.customer_type == "pharmacy"
          ? orderDetailData?.pharmacy?.city?.name
          : "--",
    },
  ];

  const SuperAdminLevel1 = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedL1User?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedL1User?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedL1User?.mobile,
    },
    {
      label: "Level",
      value: "Level 1",
    },
  ];
  const SuperAdminLevel2 = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedL2User?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedL2User?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedL2User?.mobile,
    },
    {
      label: "Level",
      value: "Level 2",
    },
  ];
  const SuperVendorLevel1 = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedL1Vendor?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedL1Vendor?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedL1Vendor?.mobile,
    },
    {
      label: "Level",
      value: "Level 2",
    },
  ];
  const SuperVendorLevel2 = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedL2Vendor?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedL2Vendor?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedL2Vendor?.mobile,
    },
    {
      label: "Level",
      value: "Level 2",
    },
  ];
  const admin = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedAdmin?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedAdmin?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedAdmin?.mobile,
    },
    {
      label: "Level",
      value: "Admin",
    },
  ];
  const vendor = [
    {
      label: "Name",
      value: orderDetailData?.invoiceVerifiedVendor?.name,
    },
    {
      label: "Email",
      value: orderDetailData?.invoiceVerifiedVendor?.email,
    },
    {
      label: "Mobile",
      value: orderDetailData?.invoiceVerifiedVendor?.mobile,
    },
    {
      label: "Level",
      value: "Manufacturer",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/manage-order",
      breadcrumb: " / manage orders",
    },
    {
      path: "/manage-order/view/:id",
      breadcrumb: orderDetailData?.doctor?.code
        ? ` / ${orderDetailData?.doctor?.code} - view`
        : " / view",
    },
  ];

  const getStatusColor = (status) => {
    if (status === "pending") {
      return "text-warning";
    } else if (status === "rejected") {
      return "text-danger";
    }
    return orderStatus?.find((e) => e?.status === status)?.color;
  };

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <>
        <div className="products-page">
          <div className="products-main-div">
            <div className="mx-3">
              {breadcrumbs.map(({ match, breadcrumb }) => (
                <NavLink
                  key={match.pathname}
                  to={match.pathname}
                  className="header-route-page fw_400 cursor_pointer"
                >
                  <span className="fs_18">{breadcrumb}</span>
                </NavLink>
              ))}
            </div>
            <div className="products-main-list my-2 py-1">
              <div className="search-container d-flex justify-content-between">
                <div
                  className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                  onClick={() => navigate(-1)}
                >
                  <img src={back} alt="back_btn" />
                  <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                    BACK
                  </span>
                </div>
              </div>
              <div style={{ position: "relative" }}>
                {loading == true ? (
                  <div className="list-spinner-container">
                    <LoadingSpinnerTable />
                  </div>
                ) : (
                  <>
                    <div className="scrolling">
                      <>
                        <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                          Customer Details
                        </div>
                        <div className="my-3 pt-4 ps-3 ms-2 row">
                          {customerDetails?.map((item, index) => (
                            <div
                              key={index}
                              className="mb-2 col-md-5 col-lg mx-2"
                            >
                              <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                {item.heading}
                              </h5>

                              <p
                                className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                              >
                                {item.title}
                              </p>
                            </div>
                          ))}
                        </div>
                      </>
                      <>
                        {orderDetailData?.invoice_verified_by ==
                          "super_admin" && (
                          <>
                            <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                              Invoice Verification Details
                            </div>
                            {orderDetailData?.invoiceVerifiedL1User !==
                              null && (
                              <div className="my-3 pt-4 ps-3 ms-2 row">
                                {SuperAdminLevel1?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>

                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                            {orderDetailData?.invoiceVerifiedL2User !==
                              null && (
                              <div className="my-3 ps-3 ms-2 row">
                                {SuperAdminLevel2?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>
                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                        {orderDetailData?.invoice_verified_by ==
                          "super_user" && (
                          <>
                            <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                              Invoice Verification Details
                            </div>
                            {orderDetailData?.invoiceVerifiedL1Vendor !==
                              null && (
                              <div className="my-3 pt-4 ps-3 ms-2 row">
                                {SuperVendorLevel1?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>

                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                            {orderDetailData?.invoiceVerifiedL2Vendor !==
                              null && (
                              <div className="my-3 ps-3 ms-2 row">
                                {SuperVendorLevel2?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>
                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                        {orderDetailData?.invoice_verified_by == "admin" && (
                          <>
                            <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                              Invoice Verification Details
                            </div>
                            {orderDetailData?.invoiceVerifiedAdmin !== null && (
                              <div className="my-3 pt-4 ps-3 ms-2 row">
                                {admin?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>

                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                        {orderDetailData?.invoice_verified_by == "vendor" && (
                          <>
                            <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                              Invoice Verification Details
                            </div>
                            {orderDetailData?.invoiceVerifiedL1Vendor !==
                              null && (
                              <div className="my-3 pt-4 ps-3 ms-2 row">
                                {vendor?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="mb-2 col-md-5 col-lg mx-2"
                                  >
                                    <h5 className="color_b0b3c7 text-nowrap fs_15 fs_xs_10 fs_sm_12 fw_500 m-0">
                                      {item.label}
                                    </h5>

                                    <p
                                      className={`fs_16 fs_xs_12 fs_sm_14 fn_Nunito text-nowrap fw_600`}
                                    >
                                      {item.value}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </>

                      <div className="d-flex text-left px-3 mx-4 my-3 py-1 form-sub-details fw_600">
                        Order Details
                      </div>
                      <div className="mx-4">
                        <OrdersTable
                          tableData={orderDetailData?.orderProducts}
                          total={orderDetailData?.total}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="products-main-list my-2 py-1 px-4 py-3">
              <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                Approvals
              </div>
              <p className="color_b0b3c7 text-nowrap fs_14 fw_500 mt-4 mx-2">
                Approval History
              </p>
              <div className="modal-table-container w-50">
                <TableContainer>
                  <thead>
                    <tr className="table-rows color_747f9e">
                      <th className="table-heads " width={"2%"}>
                        #
                      </th>
                      <th className="table-heads " width={"8%"}>
                        Name
                      </th>
                      <th className="table-heads " width={"6%"}>
                        Status
                      </th>
                      <th className="table-heads " width={"5%"}>
                        Approval Level
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetailData?.approval_users?.map((item, index) => (
                      <tr className="table-rows1" key={index}>
                        <td className="table-each-row-data" width={"2%"}>
                          {index + 1}
                        </td>
                        <td className="table-each-row-data">
                          {item?.name ?? "--"}
                        </td>
                        <td className="table-each-row-data">
                          <span
                            className={`${getStatusColor(
                              item.approved === true ? "approved" : "pending"
                            )} text-capitalize`}
                          >
                            {item.approved === true ? "approved" : "pending"}
                          </span>
                        </td>
                        <td className="table-each-row-data">
                          {item.approval_level ?? "--"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
        <ImageViewModal
          show={imageModal}
          ShowClose={() => setImageModal(false)}
          imageTitleData={imageTitleData}
          imageUrlData={imageUrlData}
        />
      </>
    </>
  );
};

export default ManageOrderDetail;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status " },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Invoiced", color: "text-green " },
  {
    status: "partially_invoiced",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
